// The account gate's codes, in a module that imports nothing: AuthHelpers (loaded while _metronic/helpers is still
// initialising) needs them, and anything that pulls the helpers in from here would read them before they exist
// (60.11.609 did not start for that reason).

/** 403 for an account still without its own mobile, name, username or password (backend 1.0.0.757+). */
export const ACCOUNT_INCOMPLETE = 'ACCOUNT_INCOMPLETE'

/** 403 for a sign-in past the two of its device kind (backend 1.0.0.757+). */
export const DEVICE_LIMIT = 'DEVICE_LIMIT'

/** Raised by the interceptor so the session is read again and the gate's page shows. */
export const ACCOUNT_INCOMPLETE_EVENT = 'megapay:account:incomplete'
